export default {
    bem_vindo: {
        titulo: 'Bienvenido',
        paragrafo1: 'Bienvenido a VAM (Veus Automation Management), un panel donde puede visualizar y controlar todas sus automatizaciones, ya sea con su equipo local o con laboratorios de apoyo.',
        paragrafo2: 'A través de este Panel y esta plataforma podrá monitorear y controlar todas las actividades de sus VNS\'s y mucho más, de una manera simple, fácil e intuitiva.',
    },
    novidades: {
        titulo: 'Novidades',
        rnds: {
            titulo: 'RNDS',
            data: '20/12/2020',
            texto: 'Nuestro sistema está homologado y brindando integración al RNDS, transmitiendo resultados COVID.'
        },
        lancamento: {
            titulo: 'Lanzamiento',
            data: '02/04/2020',
            texto: 'Hemos lanzado oficialmente nuestra plataforma a producción, ahora puedes vivir con nosotros una revolución en el área de la salud.'
        },
        monitoramento: {
            titulo: 'Supervisión',
            data: '25/03/2020',
            texto: 'Ahora es posible monitorear todas las Órdenes y Resultados de tus integraciones a través del Menú de Monitores.'
        },
        dashboard: {
            titulo: 'Dashboard',
            data: '01/02/2020',
            texto: 'Nuestro Dashboard está listo para acceder, rastree todos sus datos de automatización a través de él.'
        }
    }
}